<!-- 工作经历 -->
<template>
  <div class="edit-boxs">
    <!--公司名称-->
    <div class="edit-item">
      <p>公司名称</p>
      <input type="text" placeholder="请输入公司名称" class="printf-input" v-model="company" />
    </div>
    <!-- 职位名称 -->
    <div class="edit-item">
      <p>职位名称</p>
      <input type="text" placeholder="如：销售经理" class="printf-input" v-model="positionName" />
    </div>
    <!-- 在职时间 -->
    <div class="edit-item">
      <p>在职时间</p>
      <div class="work-time">
        <span @click="selectDate(0)">{{entryTime}}</span>
        <span @click="selectDate(1)">{{turnoverTime}}</span>
        <van-popup v-model="showPicker" round position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            :title="statusDate==0?'选择入职日期':'选择离职日期'"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="showPicker=false"
            @confirm="confirm"
          />
        </van-popup>
      </div>
    </div>
    <!-- 工作描述 -->
    <div class="edit-item">
      <p>工作描述</p>
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="200"
        placeholder="描述你在该公司的主要工作内容"
        show-word-limit
      />
    </div>
  </div>
</template>

<script>
import { workDetails } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  data() {
    return {
      lists: [],
      showPicker: false,
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      statusDate: 0, //入职状态 0 入职时间 1 离职时间
      entryTime: "", //入职时间
      turnoverTime: "至今", //离职时间
      message: "", //工作描述
      company: "", //公司名称
      positionName: "", //职务名称
      id: ""
    };
  },
  computed: {
    list: {
      get() {
        var that = this;
        let {
          company,
          positionName,
          entryTime,
          turnoverTime,
          message,
          lists
        } = that;
        lists[0] = company.replace(/[, ]/g, "");
        lists[1] = positionName.replace(/[, ]/g, "");
        lists[2] = entryTime;
        lists[3] = turnoverTime;
        lists[4] = message.replace(/[, ]/g, "");
        return lists;
      },
      set(val) {}
    }
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.workExproess();
      },
      deep: true //深度监听(可监听到对象、数组的变化)
    }
  },
  methods: {
    // 时间弹窗状态
    selectDate(val) {
      var that = this;
      that.statusDate = val;
      that.showPicker = true;
    },
    // 选定时间
    confirm(val) {
      var that = this;
      var statusDate = that.statusDate;
      var Y = val.getFullYear();
      var M = val.getMonth() + 1;
      M = M >= 10 ? M : "0" + M;
      if (statusDate == 0) {
        that.statusDate = 0;
        that.minDate = val;
        // 选择入职日期
        that.entryTime = `${Y}-${M}`;
      } else {
        that.statusDate = 1;
        that.turnoverTime = `${Y}-${M}`;
      }
      that.showPicker = false;
    },
    // 传值给父组件
    workExproess() {
      var that = this;
      let list = that.list;
      if (
        list[0].length>0 &&
        list[1].length>0  &&
        list[2].length>0 &&
        list[3] .length>0  &&
        list[4].length>0 
      ) {
        that.$emit("sendWork", list, false);
      }else{
          that.$emit("sendWork", [], true);
      }
    },
    // 获取详情
    getDetails() {
      var that = this;
      let id = that.id;
      workDetails({ resume_work_id: id }).then(res => {
        //(res);
        if (res.code == 1) {
          that.company = res.data.company;
          that.positionName = res.data.jobs;
          that.entryTime = res.data.start_time;
          that.turnoverTime = res.data.todate == 1 ? "至今" : res.data.end_time;
          that.message = res.data.description;
        } else {
          Toast(res.msg);
          setTimeout(() => {
            that.$router.back();
          }, 2000);
        }
      });
    }
  },
  created() {
    var date = new Date();
    this.maxDate = date;
    this.id = this.$route.params.id;
  },
  mounted() {
    if (this.$route.params.title == 5) {
      this.getDetails();
    }
  }
};
</script>
<style lang='less' scoped>
// 信息填写
/deep/.van-field__control::-webkit-input-placeholder {
  font-weight: 400;
  line-height: 0.42rem;
  font-size: 0.3rem;
  color: rgba(204, 204, 204, 1);
}
.edit-boxs {
  padding: 0.2rem 0.44rem;
  font-size: 0.3rem;
  text-align: left;
  .edit-item {
    padding: 0.36rem 0;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    p {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
    }
    .printf-input {
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      width:100%;
      margin-top: 0.1rem;
    }
    .printf-input::-webkit-input-placeholder {
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }

    .van-cell {
      padding: 0.1rem 0;
    }
    // 在职时间
    .work-time {
      display: flex;
      margin-top: 0.13rem;
      span {
        font-size: 0.3rem;
        font-weight: bold;
        line-height: 0.42rem;
        color: rgba(51, 51, 51, 1);
        display: flex;
        align-items: center;
        flex: 1;
      }
      span:first-child::after {
        position: absolute;
        content: "";
        display: block;
        width: 0.3rem;
        height: 0.02rem;
        background: #707070;
        left: 33%;
      }
    }
  }
}
</style>